__turbopack_context__.v({
  "className": "fraunces_292e69d6-module__B5bR_G__className",
});
